import Svg, { Path, Rect } from "react-native-svg";

const InvalidDocumentIcon = ({ size }: DocumentIconSVG) => {
  return (
    <Svg fill="none" height={size} viewBox="0 0 36 36" width={size}>
      <Rect fill="#FAE9E8" height="36" rx="8" width="36" />
      <Path
        d="M7.83594 9.46094L11 11.8867V11.5C11 10.2695 11.9844 9.25 13.25 9.25H19.0508C19.6484 9.25 20.2109 9.49609 20.6328 9.91797L23.832 13.1172C24.2539 13.5391 24.5 14.1016 24.5 14.6992V22.4688L28.6484 25.7734C29.0352 26.0547 29.1055 26.582 28.7891 26.9336C28.5078 27.3203 27.9805 27.3906 27.6289 27.0742L6.81641 10.7617C6.42969 10.4805 6.35938 9.95312 6.67578 9.60156C6.95703 9.21484 7.48438 9.14453 7.83594 9.46094ZM12.6875 13.2227L22.8125 21.168V14.875H20C19.3672 14.875 18.875 14.3828 18.875 13.75V10.9375H13.25C12.9336 10.9375 12.6875 11.2188 12.6875 11.5V13.2227ZM22.25 25.5625C22.3906 25.5625 22.5664 25.4922 22.6719 25.3867L23.9727 26.4414C23.5859 26.9336 22.9531 27.25 22.25 27.25H13.25C11.9844 27.25 11 26.2656 11 25V16.1758L12.6875 17.5117V25C12.6875 25.3164 12.9336 25.5625 13.25 25.5625H22.25Z"
        fill="#C61910"
      />
    </Svg>
  );
};

export default InvalidDocumentIcon;
